import { EnumOption } from "./enum-option"

export const StepStatus = {
    NotStarted: 0,
    InProgress: 1,
    Completed: 2,
    NotApplicable: 3,
}

export const StepStatusList: EnumOption[] = [
    { value: StepStatus.NotStarted, label: 'Not Started' },
    { value: StepStatus.InProgress, label: 'In Progress' },
    { value: StepStatus.Completed, label: 'Completed' },
    { value: StepStatus.NotApplicable, label: 'Not Applicable' },
]
